var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControlsMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_567_3",
    "data-name": "Component 567 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13288",
    "data-name": "Group 13288",
    transform: "translate(57 -284)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10698",
    "data-name": "Rectangle 10698",
    width: 24,
    height: 24,
    transform: "translate(-57 284)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13287",
    "data-name": "Group 13287",
    transform: "translate(61 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin",
    transform: "translate(-112.203 286.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10473",
    "data-name": "Path 10473",
    d: "M39.338,22.578a6.054,6.054,0,0,0-2.457,11.586l2.089,3.618a.469.469,0,0,0,.812,0L41.9,34.117a6.053,6.053,0,0,0-2.559-11.539ZM41.38,33.323a.466.466,0,0,0-.219.2L39.376,36.61l-1.761-3.05a.468.468,0,0,0-.227-.2,5.116,5.116,0,1,1,3.992-.039Z",
    transform: "translate(-33.285 -22.578)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10474",
    "data-name": "Path 10474",
    d: "M52.512,38.551A2.992,2.992,0,1,0,55.5,41.543,3,3,0,0,0,52.512,38.551Zm0,5.187a2.195,2.195,0,1,1,2.195-2.195A2.2,2.2,0,0,1,52.512,43.738Z",
    transform: "translate(-46.322 -35.353)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10475",
    "data-name": "Path 10475",
    d: "M20.554,5.351a.892.892,0,0,1-.892-.892V1.783H16.986a.892.892,0,0,1,0-1.784h3.568a.892.892,0,0,1,.892.892V4.459a.892.892,0,0,1-.892.892Zm0,16.055H16.986a.892.892,0,0,1,0-1.784h2.676V16.946a.892.892,0,1,1,1.784,0v3.568a.892.892,0,0,1-.892.892ZM.931,5.351a.892.892,0,0,1-.892-.892V.892A.892.892,0,0,1,.931,0H4.5a.892.892,0,1,1,0,1.784H1.823V4.459a.892.892,0,0,1-.892.892ZM4.5,21.406H.931a.892.892,0,0,1-.892-.892V16.946a.892.892,0,0,1,1.784,0v2.676H4.5a.892.892,0,1,1,0,1.784Z",
    transform: "translate(-117.039 283)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsMenu);
export default __webpack_public_path__ + "static/media/controls-menu.c877fb01dc055851b637adf8e74cd249.svg";
export { ForwardRef as ReactComponent };